import { Injectable } from '@angular/core';
import { Transaction } from '../entities/transaction';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@mobileia/core';

@Injectable({
  providedIn: 'root'
})
export class TransactionService extends BaseTableService<Transaction> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/transaction';
  }
  
  changeStatus(itemId: number, status: number): Observable<ApiResponse<Transaction>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/change-status', { id: itemId, status: status });
  }

  saveInvoice(itemId: number, invoice: string): Observable<ApiResponse<Transaction>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/save-invoice', { id: itemId, invoice_pdf: invoice });
  }

  sendInvoice(itemId: number): Observable<ApiResponse<Transaction>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/send-invoice', { id: itemId });
  }
}
